/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-restricted-syntax */
/* eslint-disable react/destructuring-assignment */
import { ActionIcon, Group, OptionsFilter, Select } from '@mantine/core';
import { showNotification } from '@mantine/notifications';
import { IconRefresh, IconTool } from '@tabler/icons-react';
import { useEffect, useState } from 'react';
import { ProposalServiceType } from '../../../models/core/proposals.type';
import proposalsService from '../../../services/core/proposals.service';
import theme from '../../../theme';
import { SessionStorageKey } from '../../../utils/constants.utils';
import { transformComboBoxGroupDataFromV5toV7 } from '../../../utils/mantine.utils';
import ProfileCardLink from '../ProfileCardLink/ProfileCardLink';

type FormViewProps = {
  idProposta: number;
  label: string;
  formItem: any;
  idsToBeDisabled: number[];
  disabled: boolean;
  callback(item: ProposalServiceType | null): void;
  zIndex: number;
  useCache: boolean;
};

export default function ProposalServicePicker(props: FormViewProps) {
  const [data, setData] = useState<ProposalServiceType[]>([]);
  const [loading, setLoading] = useState(false);

  const confirmActionResult = (item: ProposalServiceType | null, confirmed: boolean) => {
    if (!confirmed) {
      return;
    }
    props.callback(item);
  };

  const loadData = async () => {
    try {
      setLoading(true);
      const result = await proposalsService.listServices({
        idProposta: props.idProposta,
        cache: props.useCache,
      });
      setData(result);
      sessionStorage.setItem(
        `${SessionStorageKey.ProposalServiceList}_${props.idProposta}`,
        JSON.stringify(result)
      );
    } catch (error: any) {
      showNotification({
        title: `Proposta - Serviços`,
        message: error?.isBusinessException
          ? error.description
          : 'Não foi possível listar os serviços dessa proposta.',
        color: 'red',
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (props.useCache) {
      const cacheResult = JSON.parse(
        sessionStorage.getItem(`${SessionStorageKey.ProposalServiceList}_${props.idProposta}`) || '[]'
      ) as ProposalServiceType[];

      if (cacheResult.length > 0) {
        setData(cacheResult);
      } else {
        loadData();
      }
    } else {
      loadData();
    }
  }, []);

  const handleRefresh = () => {
    loadData();
  };

  const optionsFilter: OptionsFilter = ({ options, search }) => {
    if (search.trim().length === 0) {
      return options;
    }

    const filteredData = data
      .filter((x) => {
        const value = `${x.idPropostaServico}|${x.idServico}|${x.servico}|${
          x.residuoAcondicionamento || x.residuoEquipamento || 'Fornecedor'
        }`;
        return value.toLowerCase().includes(search.toLowerCase());
      })
      .map((y) => y.idPropostaServico?.toString());

    const filteredOptions = [];
    for (const option of options) {
      const items = (option as any).items.filter((x: any) => filteredData.includes(x.value));
      if (items.length > 0) {
        filteredOptions.push({
          ...option,
          items,
        });
      }
    }
    return filteredOptions;
  };

  return (
    <Group grow preventGrowOverflow={false} wrap="nowrap">
      <Select
        key={`proposal-service-picker_${props.formItem.value?.toString()}`}
        leftSection={<IconTool size={15} />}
        label={props.label}
        placeholder="Selecione..."
        data={transformComboBoxGroupDataFromV5toV7(
          data.map((x) => {
            return {
              label: `# ${x.idPropostaServico} - ${x.servico} - ${
                x.residuoAcondicionamento || x.residuoEquipamento || 'Fornecedor'
              }`,
              value: x.idPropostaServico!.toString(),
              disabled: props.idsToBeDisabled.includes(x.idPropostaServico!),
              group: x.servico.toUpperCase()[0],
            };
          })
        ).sort((a, b) => a.group.localeCompare(b.group))}
        clearable
        searchable
        filter={optionsFilter}
        disabled={props.disabled || loading}
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        renderOption={({ option, checked }) => {
          const row = data.find((x) => x.idPropostaServico!.toString() === option.value)!;
          return (
            <ProfileCardLink
              id={row.idServico.toString()}
              name={row.servico}
              nameSize="sm"
              description={row.residuoAcondicionamento || row.residuoEquipamento || 'Fornecedor'}
              descriptionSize="xs"
              linkPrefix="services"
              showLink={false}
            />
          );
        }}
        required
        {...props.formItem}
        value={props.formItem.value?.toString()}
        onOptionSubmit={(value: string) => {
          confirmActionResult(data.find((x) => x.idPropostaServico!.toString() === value) || null, true);
        }}
        comboboxProps={{ zIndex: props.zIndex + 1 }}
      />
      <ActionIcon
        style={{ marginLeft: -10, marginTop: 20, maxWidth: 15 }}
        radius="sm"
        color="primary"
        variant="outline"
        onClick={handleRefresh}
        disabled={props.disabled || loading}
        loading={loading}
      >
        <IconRefresh size={15} color={theme?.colors?.primary?.[6]} />
      </ActionIcon>
    </Group>
  );
}
